import React from 'react';

import Imgtpfooter from '../images/topfooter.png';
import Lgftgstore from '../images/logo_ft_gstore.png';
import Lgshoppe from '../images/logo_shoppe_ft.png';
import Lgtokped from '../images/logo_tokped.png';
import Lgtiktok from '../images/logo_tiktok_shop.png';

import tiktok_sc from '../images/tiktok.png';
import ig_sc from '../images/instagram.png';
import yt_sc from '../images/youtube.png';
import wtobuy from '../images/where_to_buy.png';

function TopFooter() {

    return (
        <div id="wheretoby" class="max-w-full px-4 py-0 sm:px-6 lg:px-0 lg:py-0 mx-auto bg-[#fefaed] hidden lg:block" style={{ backgroundImage: `url(${Imgtpfooter})`, height: 420, backgroundRepeat: 'no-repeat', backgroundSize: '100%' }}>
            <div class="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-2">
                <div class="w-full flex flex-col items-center">
                    <div
                        class="w-[280px] mt-56 bg-[#FFF8E8] rounded-lg border border-[#FF9F3E] p-4 flex flex-col items-center space-y-3"
                    >
                        <p class="text-[#FF9F3E] font-semibold">Lets hang on socials!</p>
                        <div class="flex space-x-3">
                            <a
                                href="https://www.tiktok.com/@jftheskinspecialist.id" target="_blank"
                                class="text-[#FF9F3E] bg-[#FFF8E8] p-2 rounded-lg border border-[#FF9F3E] hover:bg-[#FF9F3E] hover:text-white transition"
                            >
                                <img src={tiktok_sc} alt="" />
                            </a>
                            <a
                                href="https://www.instagram.com/jftheskinspecialist" target="_blank"
                                class="text-[#FF9F3E] bg-[#FFF8E8] p-2 rounded-lg border border-[#FF9F3E] hover:bg-[#FF9F3E] hover:text-white transition"
                            >
                                <img src={ig_sc} alt="" />
                            </a>
                            <a
                                href="https://youtu.be/BCnCoACZZQU?si=rQxpup0iZzf3-GD1" target="_blank"
                                class="text-[#FF9F3E] bg-[#FFF8E8] p-2 rounded-lg border border-[#FF9F3E] hover:bg-[#FF9F3E] hover:text-white transition"
                            >
                                <img src={yt_sc} alt="" />
                            </a>
                        </div>
                    </div>
                </div>
                <div class="w-full">
                    <div class="h-[420px] flex flex-col items-center">
                        <div class="mt-56 flex flex-col items-center space-y-4">
                            <img src={wtobuy} class="h-[30px]" />
                            <br />
                            <div class="flex space-x-4">
                                <a href="https://g-store.id" target="_blank">
                                <img
                                    src={Lgftgstore}
                                    alt="g-store"
                                    class="h-[55px]"
                                />
                                </a>
                                <a href="https://shopee.co.id/galeniumstore.id?page=0&shopCollection=16283526" target="_blank">
                                <img
                                    src={Lgshoppe}
                                    alt="Shopee"
                                    class="h-[55px]"
                                />
                                </a>
                                <a href="https://www.tokopedia.com/galenium/etalase/jf-the-skin-specialist" target="_blank">
                                <img
                                    src={Lgtokped}
                                    alt="Tokopedia"
                                    class="h-[55px]"
                                />
                                </a>
                                <a href="https://www.tiktok.com/@jftheskinspecialist.id" target="_blank">
                                <img
                                    src={Lgtiktok}
                                    alt="TikTok Shop"
                                    class="h-[45px]"
                                />
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default TopFooter;
